<template>
<v-container fluid class="register-page">
    <v-row justify="center" class="py-6">
      <v-col cols="12" md="11" lg="10">

        <v-card class="auth-card rounded-xl overflow-hidden" elevation="8">
          <v-row no-gutters>
            <v-col cols="12" md="4" class="d-none d-md-flex">
              <v-img src="/images/login.jpg" class="auth-visual" gradient="to bottom, rgba(0,105,92,.15), rgba(20,35,63,.92)">
                <div class="d-flex flex-column fill-height justify-end pa-8 white--text">
                  <v-icon size="44" class="mb-3">mdi-domain</v-icon>
                  <div class="text-h5 font-weight-bold">Register Your School</div>
                  <div class="auth-visual-subtitle mt-2">
                    Join schools already managing results, attendance, tokens and more on MYSCH — all in one place.
                  </div>
                </div>
              </v-img>
            </v-col>

            <v-col cols="12" md="8">
                <v-card-text class="pa-8 pa-md-10">
                    <div class="text-overline font-weight-bold accent--text">GET STARTED</div>
                    <div class="text-h5 font-weight-bold mb-1">Create your school account</div>
                    <div class="text-body-2 grey--text mb-6">Fill in the details below to set up your school on MYSCH.</div>

                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                    >
                        <v-row>
                            <v-col md="6" cols="12">
                                <v-text-field
                                v-model="record.school_name"
                                :rules="[v => !!v || 'School name is required!']"
                                label="School Name"
                                prepend-inner-icon="mdi-school-outline"
                                outlined
                                required
                                dense
                                ></v-text-field>
                            </v-col>

                            <v-col md="6" cols="12">
                                <v-text-field
                                v-model="record.motto"
                                :rules="[v => !!v || 'School Motto/Slogan is required!']"
                                label="School Motto/Slogan"
                                prepend-inner-icon="mdi-format-quote-close"
                                outlined
                                required
                                dense
                                ></v-text-field>
                            </v-col>

                            <v-col md="6" cols="12">
                                <v-text-field
                                v-model="record.address"
                                :rules="[v => !!v || 'Address is required!']"
                                label="School Address"
                                prepend-inner-icon="mdi-map-marker-outline"
                                outlined
                                required
                                dense
                                ></v-text-field>
                            </v-col>
                            <v-col md="6" cols="12">
                                <v-select
                                    v-model="record.school_size"
                                    :items="['10-50', '51-100', '101-150', '151-200', '201-300', '301-500', '501-1000', '>1000']"
                                    :rules="[v => !!v || 'Size is required!']"
                                    label="Students Size"
                                    prepend-inner-icon="mdi-account-group-outline"
                                    outlined
                                    required
                                    dense
                                ></v-select>
                            </v-col>
                            <v-col md="6" cols="12">
                                <v-text-field
                                v-model="record.fullname"
                                :rules="nameRules"
                                label="Your Name"
                                prepend-inner-icon="mdi-account-outline"
                                outlined
                                required
                                dense
                                ></v-text-field>

                            </v-col>

                            <v-col md="6" cols="12">
                                <v-text-field
                                v-model="record.email"
                                :rules="emailRules"
                                label="E-mail Address"
                                prepend-inner-icon="mdi-email-outline"
                                outlined
                                required
                                dense
                                ></v-text-field>
                            </v-col>

                            <v-col md="6" cols="12">
                                <v-text-field
                                v-model="record.phone"
                                :rules="phoneRules"
                                label="Phone/Mobile Number"
                                prepend-inner-icon="mdi-phone-outline"
                                outlined
                                required
                                dense
                                ></v-text-field>
                            </v-col>

                            <v-col md="6" cols="12">
                                <v-text-field
                                v-model="record.password"
                                :rules="passwordRules"
                                label="Password"
                                type="password"
                                prepend-inner-icon="mdi-lock-outline"
                                outlined
                                required
                                dense
                                ></v-text-field>
                            </v-col>

                            <v-col md="6" cols="12">
                                <v-text-field
                                v-model="record.cpassword"
                                :rules="cpasswordRules"
                                label="Confirm Password"
                                type="password"
                                prepend-inner-icon="mdi-lock-check-outline"
                                outlined
                                required
                                dense
                                ></v-text-field>
                            </v-col>

                            <v-col md="6" cols="12">
                                <v-text-field
                                v-model="record.partner_code"
                                label="Partner Code (optional)"
                                hint="If registering via a partner, enter their code here"
                                persistent-hint
                                prepend-inner-icon="mdi-handshake-outline"
                                outlined
                                dense
                                ></v-text-field>
                            </v-col>

                            <v-col md="6" cols="12" class="d-flex align-center">
                                <v-checkbox
                                v-model="record.policy"
                                :rules="[v => !!v || 'You must agree to continue!']"
                                required
                                >
                                <template v-slot:label>
                                    <div>
                                    I agree to the
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                        <a
                                            @click="tosModal = !tosModal"
                                            v-on="on"
                                        >
                                            Terms &amp; Privacy Policy
                                        </a>
                                        </template>
                                        Click to Read
                                    </v-tooltip>
                                    </div>
                                </template>
                                </v-checkbox>
                                <tos v-if="tosModal"/>
                            </v-col>

                            <v-col md="12" class="mt-2">
                                <v-btn
                                :disabled="!valid"
                                color="primary"
                                large
                                rounded
                                elevation="2"
                                class="font-weight-bold text-none mr-4"
                                @click="signup"
                                >
                                Create Account
                                <v-icon right>mdi-arrow-right</v-icon>
                                </v-btn>

                                <v-btn
                                class="text-none"
                                text
                                @click="reset"
                                >
                                Reset Form
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-col>
          </v-row>
        </v-card>
        <div class="text-center mt-3">
          <a class="image-credit" href="https://www.freepik.com/free-vector/hand-drawn-woman-with-drink_18037239.htm#fromView=keyword&page=1&position=6&uuid=5fa1b5bc-1053-4a01-a73d-94371d2f11eb" target="_blank">Image Credits</a>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import Tos from '../../components/Tos.vue';

  export default {
    name: 'Signup',
    components: {
        Tos,
    },
    mounted() {
       if (this.authToken) {
            this.$router.push({name: 'ModuleSelector'})
       }
       // Pre-fill partner code from URL query parameter
       if (this.$route.query.partner_code) {
           this.record.partner_code = this.$route.query.partner_code
       }
    },
    data: () => ({
        authToken:sessionStorage.getItem('authToken') ?? null,
        tosModal:false,
        record:{
            fullname:null,
            email:null,
            password:null,
            cpassword:null,
            phone:null,
            school_name:null,
            motto:null,
            school_size:null,
            address:null,
            policy:null,
            partner_code: null,
        },
        valid: true,
        nameRules: [
            v => !!v || 'Fullname is required',
            v => (v && v.length <= 50) || 'Fullname must be less than 50 characters',
        ],
        phoneRules: [
            v => !!v || 'Phone number is required',
            v => (v && v.length >= 10 && v.length <= 17) || 'Phone must be between 10-17 characters',
        ],
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        checkbox: false,
    }),

    computed: {
        passwordRules() {
            return [
                v => !!v || 'Password is required',
                v => (v && v.length >= 8) || 'Password must be at least 8 characters long',
            ];
        },
        cpasswordRules() {
            return [
                v => !!v || 'Confirm Password is required',
                v => (v && v === this.record.password) || 'Passwords must match',
            ];
        },
    },

    methods: {
        signup () {
            let validation = this.$refs.form.validate()
            if(!validation) {
                return validation
            }
            let loader = this.$loading.show()
            axios.post(process.env.VUE_APP_AUTHURL+'/signup', this.record,
            {
                headers:
                    {
                        'Device-Referrer-Id': process.env.VUE_APP_DEVICEID
                    }
            })
            .then(() => {
                this.$toast.success('New Account Created! You may now Login', {
                    timeout: 5000
                });
                this.$router.push({name: 'Login'})
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
        reset () {
            this.$refs.form.reset()
        },
    },
  }
</script>

<style scoped>
.register-page {
    min-height: calc(100vh - 64px);
}
.auth-visual {
    height: 100%;
    min-height: 600px;
}
.auth-visual-subtitle {
    opacity: 0.85;
    font-size: 0.9rem;
    max-width: 300px;
}
.image-credit {
    color: #9aa5b8;
    text-decoration: none;
    font-size: 11px;
}
</style>
